import {ReserveListPanelComponent} from './ReserveListPanelComponent';
import {BasePanelController} from '../../../../../BaseUI/BasePanelController';
import {ReserveService} from '../../../../../../Service/ReserveService';
import {ReservationListDTOInterface} from '../../../../../../DTO/ReservationListDTOInterface';

/**
 * 検査項目グループ管理
 */
export class ReserveListPanelController extends BasePanelController {
	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: ReserveListPanelComponent;

	/**
	 * @param param
	 */
	public async getReservationList(param: { view: any }): Promise<{
		valid: Array<ReservationListDTOInterface>;
		inValid: Array<ReservationListDTOInterface>;
	}> {

		const srv = new ReserveService(param.view);
		const res = await srv.getReservationList();

		return res;

	}

}
